// extracted by mini-css-extract-plugin
module.exports = {"root":"_a2d8e3"};